module.exports = __webpack_public_path__ + "17b18425d6d57788dc23891229cb4c92.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-sports.png
// module id = 3430
// module chunks = 0